// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file wavin/aqora/v2/metrics.proto (package wavin.aqora.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum wavin.aqora.v2.MetricType
 */
export const MetricType = proto3.makeEnum(
  "wavin.aqora.v2.MetricType",
  [
    {no: 0, name: "METRIC_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "METRIC_TYPE_AIR_TEMPERATURE_CELSIUS", localName: "AIR_TEMPERATURE_CELSIUS"},
    {no: 2, name: "METRIC_TYPE_WATER_HEIGHT_MM", localName: "WATER_HEIGHT_MM"},
    {no: 24, name: "METRIC_TYPE_WATER_HEIGHT_DIFFERENCE_MM", localName: "WATER_HEIGHT_DIFFERENCE_MM"},
    {no: 101, name: "METRIC_TYPE_DISTANCE_MM", localName: "DISTANCE_MM"},
    {no: 8, name: "METRIC_TYPE_WATER_TEMPERATURE_CELSIUS", localName: "WATER_TEMPERATURE_CELSIUS"},
    {no: 9, name: "METRIC_TYPE_WIND_SPEED_METER_PER_SECOND", localName: "WIND_SPEED_METER_PER_SECOND"},
    {no: 32, name: "METRIC_TYPE_WIND_GUST_SPEED_METER_PER_SECOND", localName: "WIND_GUST_SPEED_METER_PER_SECOND"},
    {no: 35, name: "METRIC_TYPE_WIND_DIRECTION_DEGREES", localName: "WIND_DIRECTION_DEGREES"},
    {no: 36, name: "METRIC_TYPE_WIND_GUST_DIRECTION_DEGREES", localName: "WIND_GUST_DIRECTION_DEGREES"},
    {no: 5, name: "METRIC_TYPE_PRECIPITATION_MM", localName: "PRECIPITATION_MM"},
    {no: 33, name: "METRIC_TYPE_PRECIPITATION_60MIN_ACCUMULATED_MM", localName: "PRECIPITATION_60MIN_ACCUMULATED_MM"},
    {no: 34, name: "METRIC_TYPE_PRECIPITATION_TODAY_ACCUMULATED_MM", localName: "PRECIPITATION_TODAY_ACCUMULATED_MM"},
    {no: 29, name: "METRIC_TYPE_FLOW_DIFFERENCE_L", localName: "FLOW_DIFFERENCE_L"},
    {no: 25, name: "METRIC_TYPE_FLOW_RATE_L_SECOND", localName: "FLOW_RATE_L_SECOND"},
    {no: 28, name: "METRIC_TYPE_HUMIDITY_PERCENTAGE", localName: "HUMIDITY_PERCENTAGE"},
    {no: 7, name: "METRIC_TYPE_VALVE_HEIGHT_MM", localName: "VALVE_HEIGHT_MM"},
    {no: 6, name: "METRIC_TYPE_TAP_ON", localName: "TAP_ON"},
    {no: 31, name: "METRIC_TYPE_VALVE_STATE_ON", localName: "VALVE_STATE_ON"},
    {no: 26, name: "METRIC_TYPE_PUMP_STATE_ON", localName: "PUMP_STATE_ON"},
    {no: 27, name: "METRIC_TYPE_PUMP_STATE_PERCENTAGE", localName: "PUMP_STATE_PERCENTAGE"},
    {no: 14, name: "METRIC_TYPE_DEVICE_ONLINE", localName: "DEVICE_ONLINE"},
    {no: 3, name: "METRIC_TYPE_BATTERY_PERCENTAGE", localName: "BATTERY_PERCENTAGE"},
    {no: 10, name: "METRIC_TYPE_CELLULAR_RSSI_DBM", localName: "CELLULAR_RSSI_DBM"},
    {no: 11, name: "METRIC_TYPE_PCB_TEMPERATURE_CELSIUS", localName: "PCB_TEMPERATURE_CELSIUS"},
    {no: 12, name: "METRIC_TYPE_PCB_HUMIDITY_PERCENTAGE", localName: "PCB_HUMIDITY_PERCENTAGE"},
    {no: 13, name: "METRIC_TYPE_VALVE_MOTOR_CURRENT_MA", localName: "VALVE_MOTOR_CURRENT_MA"},
    {no: 4, name: "METRIC_TYPE_POND_PLC_STATE", localName: "POND_PLC_STATE"},
    {no: 30, name: "METRIC_TYPE_STATUS_BITS", localName: "STATUS_BITS"},
    {no: 15, name: "METRIC_TYPE_KPI_EVAPORATION_L", localName: "KPI_EVAPORATION_L"},
    {no: 16, name: "METRIC_TYPE_KPI_RAIN_CAPTURED_L", localName: "KPI_RAIN_CAPTURED_L"},
    {no: 17, name: "METRIC_TYPE_KPI_RAIN_SOIL_L", localName: "KPI_RAIN_SOIL_L"},
    {no: 18, name: "METRIC_TYPE_KPI_TAP_L", localName: "KPI_TAP_L"},
    {no: 19, name: "METRIC_TYPE_KPI_SEWER_L", localName: "KPI_SEWER_L"},
    {no: 20, name: "METRIC_TYPE_KPI_RAIN_TOTAL_L", localName: "KPI_RAIN_TOTAL_L"},
    {no: 21, name: "METRIC_TYPE_KPI_PLANT_USAGE_L", localName: "KPI_PLANT_USAGE_L"},
    {no: 22, name: "METRIC_TYPE_KPI_DRAINED_DELAYED_L", localName: "KPI_DRAINED_DELAYED_L"},
    {no: 23, name: "METRIC_TYPE_KPI_WATER_STORED_L", localName: "KPI_WATER_STORED_L"},
    {no: 37, name: "METRIC_TYPE_SYSTEM_MODE", localName: "SYSTEM_MODE"},
    {no: 39, name: "METRIC_TYPE_CALCULATED_WATER_VOLUME_M3", localName: "CALCULATED_WATER_VOLUME_M3"},
    {no: 40, name: "METRIC_TYPE_CALCULATED_WATER_PERCENTAGE", localName: "CALCULATED_WATER_PERCENTAGE"},
  ],
);

/**
 * @generated from message wavin.aqora.v2.Metric
 */
export const Metric = proto3.makeMessageType(
  "wavin.aqora.v2.Metric",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(MetricType) },
    { no: 2, name: "resource_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data_points", kind: "message", T: Metric_DataPoint, repeated: true },
  ],
);

/**
 * @generated from message wavin.aqora.v2.Metric.DataPoint
 */
export const Metric_DataPoint = proto3.makeMessageType(
  "wavin.aqora.v2.Metric.DataPoint",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 4, name: "as_double", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "value" },
    { no: 6, name: "as_int", kind: "scalar", T: 16 /* ScalarType.SFIXED64 */, oneof: "value" },
  ],
  {localName: "Metric_DataPoint"},
);

